<template>
    <div class="contents">
        <div class="info-wrap">
            <div class="info__tit">
                <h3>갑상선암</h3>
                <button class="board-view__btn heart"></button>
            </div>
            <div class="info__con">
                <div class="info__left" :class="{ 'active': isBbOnTop }">
                    <ul class="accordion_lnb">
                        <li v-for="(item, index) in accordionItems" :key="index" :class="{ 'active': accordionIndex === index }">
                            <a href="javascript:;" @click="activateAccordion(index)">{{ item.title }}</a>
                            <span></span>
                        </li>
                    </ul>
                </div>
                <div class="info__right">
                    <ul class="accordion">
                        <li  v-for="(item, index) in accordionItems" :key="index" class="accordion__item" :class="{ 'active': accordionIndex === index }">
                            <a href="javascript:;" class="accordion__header" @click="accordionActive($event, index)">
                                <div class="title">
                                    <h3>{{ item.title }}</h3>
                                    <sub class="text">{{ item.subtitle }}</sub>
                                </div>
                                <span class="accordion__arrow"></span>
                            </a>
                            <div class="accordion__con--wrap">
                                <div class="accordion__con">
                                    <div class="accordion__con--text">
                                        <h3 class="depth02__title title">{{ item.contenttit }}</h3>
                                        <p>{{ item.content }}</p>
                                    </div>
                                    <a href="javascript:;" class="accordion__con--botton" @click="accordion_close()">접음</a>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
    export default {
        data() {
            return {
                isBbOnTop: false,
                accordionItems: [
                    { title: '예시1', subtitle: 'Summary Explanation',contenttit:'예시1',  content: '예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다.' },
                    { title: '예시2', subtitle: 'What is Cancer',contenttit:'예시2', content: '암에 관한 설명입니다.' },
                    { title: '예시3', subtitle: 'Prevention',contenttit:'예시3', content: '예방에 관한 설명입니다.' },
                    { title: '예시4', subtitle: 'Prevention',contenttit:'예시4', content: '예방에 관한 설명입니다.' },
                    { title: '예시5', subtitle: 'Prevention',contenttit:'예시5', content: '예방에 관한 설명입니다.니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다' },
                    { title: '예시6', subtitle: 'Summary Explanation',contenttit:'예시1',  content: '예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다. 예시입니다.' },
                   
                ],
                accordionIndex: 0,
            };
            
        },
        methods: {
            // info__left fixed 이벤트
            checkBbPosition() {
                const bbElement = document.querySelector('.info__con');
                if (bbElement) {
                    const bbPosition = bbElement.getBoundingClientRect().top;
                    this.isBbOnTop = bbPosition <= 0;
                }
            },

            // accordion__header 이벤트
            accordionActive(event,index) {
                const target = event.currentTarget;
                const parentLayer = target.closest('.accordion__item').querySelector('.accordion__con--wrap');
                if (this.accordionIndex === index) {
                    // 두 번째 클릭 시 높이를 0으로 설정
                    parentLayer.style.height = '0';
                    this.accordionIndex = -1; // 비활성화
                } else {
                    const layers = this.$el.querySelectorAll('.accordion__con--wrap');
                    layers.forEach(layer => {
                        layer.style.height = '0';
                    });
                    const ulHeight = parentLayer.querySelector('.accordion__con').offsetHeight + 'px';
                    parentLayer.style.height = ulHeight;
                    this.accordionIndex = index; // 활성화
                }
            },
            // 아코디언 닫기 이벤트
            accordion_close(event){
                    const layers = this.$el.querySelectorAll('.accordion__con--wrap');
                    layers.forEach(layer => {
                        layer.style.height = '0';
                    });
                    this.accordionIndex = -1; // 비활성화
            },
            // info__left 클릭 이벤트
            activateAccordion(index) {
                // 아코디언 닫기
                const layers = this.$el.querySelectorAll('.accordion__con--wrap');
                    layers.forEach(layer => {
                    layer.style.height = '0';
                });
                // 엑티브 되는 박스의 index
                this.accordionIndex = index;
                const accordionItem = this.$el.querySelectorAll('.accordion__item')[index];
                const accordionWrap = accordionItem.querySelector('.accordion__con--wrap');
                
                // 해당 아코디언 아이템의 내용 높이를 가져와서 설정
                const ulHeight = accordionWrap.querySelector('.accordion__con').offsetHeight + 'px';
                accordionWrap.style.height = ulHeight;
                setTimeout(() => {
                    
                    accordionItem.scrollIntoView({ behavior: 'smooth', block: 'start' }); 
                }, 400);
                
                
            }
        },
        mounted() {
            // info__left 스크롤 이벤트
            window.addEventListener('scroll', this.checkBbPosition);

            // 첫번째 accordion__item 기본 엑티브
            const first_parentLayer = document.querySelector('.accordion__item:first-of-type').querySelector('.accordion__con--wrap');
            const first_ulHeight = first_parentLayer.querySelector('.accordion__con').offsetHeight + 'px';
            if (first_parentLayer) {
                first_parentLayer.style.height = first_ulHeight;
            }else {
                console.error('첫번째accordion__item 요소를 찾을 수 없습니다.');
            }
            
        },
        beforeDestroy() {
            window.removeEventListener('scroll', this.checkBbPosition);
        }
    };
</script>